module.exports = __webpack_public_path__ + "img/서브4_패스킥슛.44118326.svg";